import { iconLogo } from '@tesla/design-system-icons';
import cx from 'classnames';
import React from 'react';
import { Icon } from '../icon/index.js';
import { NavItem } from '../nav-item/index.js';
export const InternalLogo = ({ className, href = '/', ariaLabel = 'Tesla Logo', onClick, ...rest }) => {
    return (React.createElement("div", { className: cx('tds-site-logo', className), ...rest },
        React.createElement(NavItem, { icon: React.createElement(Icon, { data: iconLogo, size: "large", "aria-label": ariaLabel }), href: href, onClick: (e) => {
                if (onClick) {
                    e.preventDefault();
                    onClick(e);
                }
            } })));
};
